module.exports = __webpack_public_path__ + "static/media/logo.99698214.PNG";